import React from 'react';
import cx from 'classnames';

export interface LoadingProps {
  className?: string;
}

export default function Loading({ className }: LoadingProps) {
  return (
    <div className={cx('p-4', className)}>
      <span className='fa fa-spinner spinning mr-2' /> Loading
    </div>
  );
}
